import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { totalComplaint } from "../../../../configration_data/configration";
import { useSelector } from "react-redux";
import ProtectedPaymentRoute from "../../../../auth/Auth";

export default function TotalComplaint() {
  ProtectedPaymentRoute();

  const navigate = useNavigate();
  const selectedType = useSelector((state) => state.corpo)?.selectedType;

  const navigateToNextPage = (e) => {
    if (e) e.preventDefault();
    if (selectedType === "C-Corp") {
      navigate("/bank_details");
    } else if (selectedType === "S-Corp") {
      navigate("/corp_question/6");
    } else {
      navigate("/bank_details");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      navigateToNextPage();
    }
  };

  const backbtn = () => {
    navigate("/agreement");
  };

  return (
    <div className="min-h-[75vh] bg-white py-12 lg:py-20 font-sans">
      <div className="container mx-auto px-4 lg:px-8 max-w-5xl">
        <div className="mb-10 text-center max-w-3xl mx-auto">
          <span className="text-[#1a73e8] font-medium tracking-wider uppercase text-xs mb-2 block">
            Annual Compliance Guarantee
          </span>
          <h1 className="text-3xl sm:text-4xl font-normal text-[#202124] tracking-tight mb-3">
            Keep your business in good standing with Total Compliance
          </h1>
          <p className="text-[15px] text-[#5f6368] leading-relaxed">
            Failing to stay compliant with state corporate laws can pierce your corporate veil and expose directors to liability. We guarantee total compliance and timely annual reports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {totalComplaint.map((ele) => (
            <div
              key={ele.title}
              className="p-6 rounded-[12px] border border-[#dadce0] bg-white hover:border-[#1a73e8]/40 hover:shadow-md transition-all flex flex-col"
            >
              <div className="w-12 h-12 rounded-full bg-[#e8f0fe] flex items-center justify-center text-[#1a73e8] mb-5 text-xl">
                <i className={ele.icon} aria-hidden="true"></i>
              </div>
              <h4 className="text-[17px] font-medium text-[#202124] mb-2">
                {ele.title}
              </h4>
              <p className="text-[14px] text-[#5f6368] leading-relaxed">
                {ele.pera}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-[#f8f9fa] rounded-[8px] p-4 text-[13px] text-[#5f6368] text-center mb-8 border border-[#dadce0] max-w-3xl mx-auto">
          Included with your corporation order for initial filing periods, then continues automatically at $280/year. Cancel online anytime.
        </div>

        <div className="flex flex-col items-center gap-4 pt-6 border-t border-[#f1f3f4] max-w-5xl mx-auto">
          <div className="flex items-center justify-between w-full">
            <button
              type="button"
              onClick={backbtn}
              className="px-6 py-2.5 rounded-[4px] border border-[#dadce0] text-[#1a73e8] font-medium hover:bg-[#f8f9fa] transition-colors flex items-center gap-2 cursor-pointer text-[14px]"
            >
              <i className="fa-solid fa-arrow-left text-xs"></i> Back
            </button>
            <button
              type="button"
              onClick={navigateToNextPage}
              onKeyDown={handleKeyPress}
              className="px-8 py-2.5 rounded-[4px] bg-[#1a73e8] hover:bg-[#1557b0] !text-white font-medium shadow-sm transition-all flex items-center gap-2 cursor-pointer text-[14px]"
            >
              Continue with Oktobiz <i className="fa-solid fa-arrow-right text-xs"></i>
            </button>
          </div>

          <Link
            to="#"
            onClick={navigateToNextPage}
            className="text-[13.5px] text-[#5f6368] hover:text-[#1a73e8] underline transition-colors mt-2"
          >
            No, thanks — I'll manage annual compliance on my own
          </Link>
        </div>
      </div>
    </div>
  );
}
